/**
 * Collapsible content handler for product accordions
 */
document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.accordion details');
  
  if (accordions.length) {
    accordions.forEach(accordion => {
      // Handle clicks on the summary element
      const summary = accordion.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (event) => {
          // Prevent default behavior to handle it ourselves
          event.preventDefault();
          
          // Toggle the open attribute
          if (accordion.hasAttribute('open')) {
            accordion.removeAttribute('open');
          } else {
            accordion.setAttribute('open', '');
          }
        });
      }
    });
  }
}); 